module.exports = __webpack_public_path__ + "static/media/Relative-Faux-Web.e6fd09ee.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Faux-Web.woff2
// module id = 737
// module chunks = 0